import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleArrowLeft = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M10.983 5.841c.56.232.926.78.926 1.386V10.5h6.455a1.5 1.5 0 0 1 0 3h-6.455v3.273a1.5 1.5 0 0 1-2.561 1.06l-4.773-4.772a1.5 1.5 0 0 1 0-2.122l4.773-4.773a1.5 1.5 0 0 1 1.635-.325'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleArrowLeft)
export default ForwardRef
